<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import api from "@/axios";
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import moment from "moment";
import {driver} from "driver.js";
import "driver.js/dist/driver.css";
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import Swal from "sweetalert2";
import Multiselect from "@vueform/multiselect";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  // DxExport segue registrado de propósito: o <DxExport> no template está
  // comentado (FLUXO ANTIGO DE EXPORTAÇÃO) e basta descomentá-lo para voltar
  // atrás, sem precisar mexer aqui também.
  // eslint-disable-next-line vue/no-unused-components
  components: { Layout, PageHeader, DxDataGrid, DxColumn, DxButton, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader, Multiselect

  },
  data() {

    return {
      title: "CT-es",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "CT-es",
          active: true
        }
      ],
      selectedItems: 0,
      dataList: null,
      totalList: 0,
      updating: false,

      dtIniFiltro: null,
      dtFimFiltro: null,
      // FLUXO NOVO DE EXPORTAÇÃO — flag própria, deliberadamente separada de
      // `updating`: aquela está no v-if que envolve a grid e a desmontaria
      // durante a exportação. Esta só desabilita os botões.
      exportando: false,
      showModalPeriodo: false,
      submittedPeriodo: false,
      bloqExibEconofrete: true,
      showCotaFrete: false,
      cepDestCotaInt: null,

      showGeraDoccob: false,
      ctes_doccob: null,
      dtListPesqPessoa: null,
      tomadorDoccob: null,
      emitsctes_doccob: null,
      dtVencDoccob: null,
      updatingdoccob: false,
      showModalListErro: false,
      dtListErro: null

    };
  },

  created() {

    // bloqueio FALSE apenas se cliente globopharma
    if (window.location.href.includes('goldendistri')){
      this.bloqExibEconofrete = false
    }

    /*if (window.location.href.includes('lelloprint')
    || window.location.href.includes('bluevix')
    || window.location.href.includes('localhost')
    || window.location.href.includes('belfar')
    || window.location.href.includes('creative')) {
      this.bloqExibEconofrete = true
    }*/

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted cte-list_00')
    this.atualizaDataList()
  },


  methods: {

    abrirCteCotaComp(){
      console.log('abrirCteCotaComp')
      this.$router.push(`/movctecotacomps/list`)
    },

    abrirFreteCotaComp(){
      console.log('abrirFreteCotaComp')
      this.$router.push(`/fretecotacomp/list`)
    },

    abrirCompAssinc(){
      console.log('abrirCompAssinc')
      console.log('abrirCompAssinc')
      this.$router.push(`/movctecompassinc/list`)
    },


    abrirConcAssinc(){
      console.log('abrirConcAssinc')
      this.$router.push(`/movctecotassinc/list`)
    },


    ajuda(){
      console.log('ajuda')
      const driverObj = driver({
        showProgress: true,
        nextBtnText: 'Próximo >',
        prevBtnText: '< Anterior',
        doneBtnText: 'Finalizar',
        steps: [
          { element: '#btnImportarXml', popover: { title: 'Importar Arquivo XML', description: 'Comece por aqui, importando o arquivo XML de seu conhecimento de transporte (CT-e).' } },
          { element: '#btnInserirXml', popover: { title: 'Criar Novo', description: 'Aqui você vai conseguir criar um novo conhecimento de transporte (CT-e).' } },
        ]
      })
      driverObj.drive()
    },



    atualizarItensSelecionados(e) {
      this.selectedItems = e.selectedRowsData.length;
    },

    criarNovoCte(){
      console.log('criarNovoCte')

      this.$router.push(`/movctefiscal/editar/0`)


    },



    nomeStatus(e) {
      switch (e.value) {
        case 'CEM':
          return 'CT-e Emitido (CEM)'
        case 'EL':
          return 'Elaboração (EL)'
        case 'CAN':
          return 'Cancelado (CAN)'
        case 'COL':
          return 'Conciliado (COL)'
      }
      return e.value
    },




    /**
     * Ids dos CT-e selecionados, tirando os cancelados na SEFAZ (status CAN).
     * O cancelamento chega pelo logstash em /api/movctelistcanc; a partir dai o
     * CT-e nao pode ser cotado nem entrar em doccob - o documento nao existe
     * mais fiscalmente e o frete dele viraria custo falso no fechamento.
     * Avisa quantos foram descartados em vez de sumir com eles em silencio.
     */
    idsSelecionadosNaoCancelados() {
      const linhas = this.dataGrid.getSelectedRowsData() || []
      const validas = linhas.filter(l => l.movcte_status !== 'CAN')
      const descartados = linhas.length - validas.length
      if (descartados > 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: `${descartados} CT-e(s) cancelado(s) na SEFAZ foram ignorados.`,
          showConfirmButton: false,
          timer: 2500
        })
      }
      return validas.map(l => l.movcte_id ?? l.id)
    },

    cotarFrete(){
      console.log('cotarFrete_cte')

      const idsAtualizar = this.idsSelecionadosNaoCancelados()
      console.log('idsAtualizar')
      console.log(idsAtualizar)
      console.log(idsAtualizar.length)

      this.updating = true

      api.get(`${getBaseUrl()}api/cotarfretectes`, {
        params: {
          'ids': idsAtualizar
        }
      }).then((res) => {
        console.log('res cotarFrete')
        console.log(res.data)

        const resEcono = res.data

        if (resEcono['SDT_WSRetorno'] && resEcono['SDT_WSRetorno']['Messages']) {
          console.log('existe erro')
          let erros = resEcono['SDT_WSRetorno']['Messages']
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          erros.forEach((erro) => {
            listaErros.push({
              'titulo': erro['Description'],
              'mensagem': erro['Type']
            })
          })
          this.errosValid = listaErros
          this.showModalCotarFrete = false
        }

        else if (resEcono[1]) {
          console.log('existe resultado')

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })


          this.atualizaDataList()

        }
      })

    },

    atualizaPagina() {
      window.location.reload();
    },


    cotarFreteInterno(){
      console.log('cotarFreteInterno_cte')
      this.showCotaFrete = true

      // const idsAtualizar = this.dataGrid.getSelectedRowKeys()
      // console.log('idsAtualizar')
      // console.log(idsAtualizar)
      // console.log(idsAtualizar.length)
      //
      // if (idsAtualizar.length === 0) {
      //   Swal.fire({
      //     position: "top-end",
      //     icon: "warning",
      //     title: "Nenhum CT'e selecionado para cotação, favor selecionar.",
      //     showConfirmButton: false,
      //     timer: 1500
      //   })
      // } else if (idsAtualizar.length > 10) {
      //   Swal.fire({
      //     position: "top-end",
      //     icon: "warning",
      //     title: "Máximo de 10 movimentos podem ser selecionados, favor selecionar menos movimentos e tentar novamente.",
      //     showConfirmButton: false,
      //     timer: 2500
      //   })
      // } else {
      //   this.updating = true
      //
      //   api.get(`${getBaseUrl()}api/cotarfretectesint`, {
      //     params: {
      //       'ids': idsAtualizar
      //     }
      //   }).then((res) => {
      //     console.log('res cotarFrete_cte_interno')
      //     console.log(res.data)
      //
      //     const resEcono = res.data
      //
      //     if (resEcono['SDT_WSRetorno'] && resEcono['SDT_WSRetorno']['Messages']) {
      //       console.log('existe erro')
      //       let erros = resEcono['SDT_WSRetorno']['Messages']
      //       console.log(erros)
      //       console.log(typeof  erros)
      //       let listaErros = []
      //       erros.forEach((erro) => {
      //         listaErros.push({
      //           'titulo': erro['Description'],
      //           'mensagem': erro['Type']
      //         })
      //       })
      //       this.errosValid = listaErros
      //       this.showModalCotarFrete = false
      //     }
      //
      //     else if (resEcono[1]) {
      //       console.log('existe resultado')
      //       Swal.fire({
      //         position: "top-end",
      //         icon: "success",
      //         title: "Cotação realizada com sucesso!",
      //         text: `Total de ${resEcono[1]} tabela(s) encontrada(s) para cotação`,
      //         showConfirmButton: false,
      //         timer: 3000
      //       })
      //       // this.atualizaDataList()
      //       this.atualizaPagina()
      //     }
      //   })
      // }
    },

    confCotarFreteInterno(){
      console.log('cotarFreteInterno_cte')
      this.showCotaFrete = false

      const idsAtualizar = this.idsSelecionadosNaoCancelados()
      console.log('idsAtualizar')
      console.log(idsAtualizar)
      console.log(idsAtualizar.length)

      if (idsAtualizar.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhum CT'e selecionado para cotação, favor selecionar.",
          showConfirmButton: false,
          timer: 1500
        })
      } else if (idsAtualizar.length > 10) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Máximo de 10 movimentos podem ser selecionados, favor selecionar menos movimentos e tentar novamente.",
          showConfirmButton: false,
          timer: 2500
        })
      } else {
        this.updating = true

        api.get(`${getBaseUrl()}api/cotarfretectesint`, {
          params: {
            'ids': idsAtualizar,
            'destcep': this.cepDestCotaInt
          }
        }).then((res) => {
          console.log('res cotarFrete_cte_interno')
          console.log(res.data)

          const resEcono = res.data

          if (resEcono['SDT_WSRetorno'] && resEcono['SDT_WSRetorno']['Messages']) {
            console.log('existe erro')
            let erros = resEcono['SDT_WSRetorno']['Messages']
            console.log(erros)
            console.log(typeof  erros)
            let listaErros = []
            erros.forEach((erro) => {
              listaErros.push({
                'titulo': erro['Description'],
                'mensagem': erro['Type']
              })
            })
            this.errosValid = listaErros
            this.showModalCotarFrete = false
          }

          else if (resEcono[1]) {
            console.log('existe resultado')
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Cotação realizada com sucesso!",
              text: `Total de ${resEcono[1]} tabela(s) encontrada(s) para cotação`,
              showConfirmButton: false,
              timer: 3000
            })
          }
          this.updating = false
          this.atualizaPagina()
        }).catch((error) => {
          console.log('erro cotarFrete_cte_interno')
          console.log(error)

          const erroData = error.response && error.response.data

          if (erroData && erroData['erro'] === 'dns_bloqueado') {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Entrar em contato com o suporte.",
              showConfirmButton: false,
              timer: 3000
            })
          }

          this.updating = false
        })
      }
    },


    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    atualizaDataList(){
      console.log('atualizaDataList_cte')
      this.updating = true


      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }


      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.updating = false

      this.dataList = new CustomStore({
        key: "movcte_id",
        load: function(loadOptions) {

          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/movctesent`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)

            const data = response.data[0];
            const totalCount = response.data[1];

            data.forEach((item, index) => {
              //diferença da cotação - Conciliação
              if (!isNaN(parseFloat(item.movcte_valor)) && !isNaN(parseFloat(item.movcte_valoratucota))) {
                const movcte_difvalcota = parseFloat(item.movcte_valoratucota) - parseFloat(item.movcte_valor);
                data[index].movcte_difvalcota = parseFloat(movcte_difvalcota);
              } else {
                data[index].movcte_difvalcota = null;
              }
              //diferença da cotação - Menor frete
              if (!isNaN(parseFloat(item.movcte_valor)) && !isNaN(parseFloat(item.movcte_valormincota))) {
                const movcte_difvalmin = parseFloat(item.movcte_valor) - parseFloat(item.movcte_valormincota);
                data[index].movcte_difvalmin = parseFloat(movcte_difvalmin);
              } else {
                data[index].movcte_difvalmin = null;
              }
              //diferença da cotação - Menor Prazo
              if (!isNaN(parseFloat(item.movcte_valor)) && !isNaN(parseFloat(item.movcte_valorprazmin))) {
                const movcte_difprazmin = parseFloat(item.movcte_valor) - parseFloat(item.movcte_valorprazmin);
                data[index].movcte_difprazmin = parseFloat(movcte_difprazmin);
              } else {
                data[index].movcte_difprazmin = null;
              }
              //frete percentual da conciliação
              if (!isNaN(parseFloat(item.movcte_valor)) && !isNaN(parseFloat(item.movcte_valormincota))) {
                const movcte_percentualcota = (parseFloat(item.movcte_valor) / parseFloat(item.movcte_valorcarga)) * 100;
                data[index].movcte_percentualcota = parseFloat(movcte_percentualcota);
              } else {
                data[index].movcte_percentualcota = null;
              }


            });

            console.log('data:', data);

            console.log('data', data)
            console.log('totalCount', totalCount)


            return {
              data: data,
              totalCount: totalCount,

            }
          })
        },
      })
    },

    imprimirdancte() {
      console.log('imprimirdancte')

      const ids = this.dataGrid.getSelectedRowKeys()
      this.$refs.dataGridRefKey.instance.clearSelection()

      if (!ids || ids.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Selecione pelo menos um CT-e para imprimir!",
          showConfirmButton: false,
          timer: 3000
        })
        return
      }

      api.post(`${getBaseUrl()}api/movctegeradancte`,
          { ids: ids },
          { responseType: 'blob' }
      ).then((res) => {
        console.log('response gerarDANFE', res)
        let filename = "lista_cte" + new Date().toISOString().slice(0, 10) + ".zip"

        const blob = new Blob([res.data], { type: 'application/octet-stream' })
        saveAs(blob, filename)
      }).catch((error) => {
        console.error('Erro ao gerar DANFE:', error)
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Falha ao gerar DANFE',
          text: (error && error.response && error.response.data) ? String(error.response.data) : '',
          showConfirmButton: false,
          timer: 3000,
        })
      })
    },

    gerarDoccob(){
      console.log('gerarDoccob')

      // Doccob nao aceita CT-e cancelado: ele soma valor no fechamento de
      // cobranca, e um documento cancelado na SEFAZ nao tem frete a cobrar.
      const ctesSelecionados = this.dataGrid.getSelectedRowsData() || []
      this.ctes_doccob = ctesSelecionados.filter(c => c.movcte_status !== 'CAN')
      if (ctesSelecionados.length !== this.ctes_doccob.length) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: `${ctesSelecionados.length - this.ctes_doccob.length} CT-e(s) cancelado(s) na SEFAZ foram ignorados.`,
          showConfirmButton: false,
          timer: 2500
        })
      }
      // console.log('ctes_doccob: ', this.ctes_doccob)

      if(this.ctes_doccob?.length > 0) {
        const existDoccb = this.ctes_doccob[0].movcte_doccobid
        if(!existDoccb) {
          this.emitsctes_doccob = [
            ...new Map(
                this.ctes_doccob.map(item => [
                  item.movcte_emitcnpj,
                  {
                    nome: item.movcte_emitnome,
                    cnpj: item.movcte_emitcnpj
                  }
                ])
            ).values()
          ];

          this.emitsctes_doccob = this.emitsctes_doccob.map(item => {
            return {
              nome: item.nome,
              cnpj: item.cnpj,
              numero: this.ctes_doccob.filter(cte => cte.movcte_emitcnpj === item.cnpj).map(num => num.movcte_numero).join(', ')
            }
          })
          this.showGeraDoccob = true
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'warning',
            title: `Existem CTe's listado que já contém DocCob registrado!"`,
            text: `Por favor, indentificar os mesmos e retire da lista para prosseguir.`,
            showConfirmButton: false,
            timer: 3000,
          })
        }
      } else {
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          title: `Nenhum CT'e foi selecionado!`,
          text: `É necessário selecionar ao menos um CT-e para gerar o DOCCOB.`,
          showConfirmButton: false,
          timer: 2500,
        })
      }
    },

    pesqPessoa(evt) {
      console.log('pesqPessoa')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqPessoa = res.data
        });
      }
    },

    escolheuPessoa() {
      console.log('escolheuPessoa')
      console.log(this.tomadorDoccob)
    },

    confirmaGerarDoccob() {
      console.log('confirmaGerarDoccob')

      if(!this.tomadorDoccob){
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          title: `O campo TOMADOR é obrigatorio!`,
          text: `Favor indicar o tomador para gerar o DOCCOB.`,
          showConfirmButton: false,
          timer: 2500,
        })
      } else if (!this.dtVencDoccob) {
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          title: `A data de VENCIMENTO é obrigatorio!`,
          text: `Favor indicar a data de vencimento para gerar o DOCCOB.`,
          showConfirmButton: false,
          timer: 2500,
        })
      } else {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: `Perfeito!`,
          text: `Estamos gerando o DocCob de acordo com os dados indicados.`,
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          this.updatingdoccob = true

          api.post(`${getBaseUrl()}api/criardoccobcte`, {
            dtvenc: this.dtVencDoccob,
            tomador: this.tomadorDoccob,
            emits: this.emitsctes_doccob,
            manual: true
          }).then((res) => {
            console.log("then axios criardoccobcte")
            console.log(res.data)
            this.updatingdoccob = false
            this.showGeraDoccob = false

            if(res.data.success === true){
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: `Criação de Registros Finalizada!`,
                text: res.data.message,
                showConfirmButton: false,
                timer: 2500,
              })

              this.refeFormTable()
              const routeData = this.$router.resolve(`/financeiros/doccobs`)
              window.open(routeData.href, '_blank')

            } else {
              Swal.fire({
                position: 'top-end',
                icon: 'warning',
                title: `Atenção! Registros Finalizadados com Ressalva!`,
                text: res.data.message,
                showConfirmButton: false,
                timer: 2500,
              }).then(() => {
                this.dtListErro = res.data.listErro
                this.showModalListErro = true
              });
            }

          })
        });
      }
    },

    carregouGrid(e) {
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) CT-es: ${dtIniFormated} - ${dtFimFormated}`
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "movcte_status") {
          const valStatus = e.data.movcte_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'CEM':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'COL':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'CAN':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        } else if (e.column.dataField === "movcte_difvalcota") {
          const valDif = e.data.movcte_difvalcota
          const valFretConc = e.data.movcte_valoratucota
          let corDif = null
          if (valFretConc <= 0 || valDif < 0 ) {
            corDif = 'rgb(248,101,101)'
          } else if (valDif === 0){
            corDif = 'rgba(125,189,110)'
          } else {
            corDif = 'rgb(5,126,236)'
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corDif}`;
        }
      }


      // if (e.rowType === "data" && e.column.movcte_difvalcota < 0 ) {
      //   e.cellElement.style.cssText = `color: red;`
      // }
      //
      // else if (e.rowType === "data" && e.column.movcte_status === 'CAN') {
      //   e.cellElement.style.cssText = `color: white; background-color:  #f26e41; text-aling: center;`
      // }
      //
      // else if (e.rowType === "data" && e.column.movcte_status === 'COL') {
      //   e.cellElement.style.cssText = `color: black; background-color:  white; text-aling: center;`
      // }
    },

    novoCte() {
      console.log('novoCte')

      const routeData = this.$router.resolve(`/movcte/importar/0`)
      window.open(routeData.href, '_blank')
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      const routeData = this.$router.resolve(`/movcte/editar/${idData}`)
      window.open(routeData.href, '_blank')
    },

    onExporting(e) {
      console.log('onExporting')
      e.cancel = true

      if (e.selectedRowsOnly) {
        // Exportar apenas selecionados — usa exportDataGrid com os dados já carregados
        const workbook = new Workbook()
        const worksheet = workbook.addWorksheet('plan1')
        exportDataGrid({
          component: e.component,
          worksheet,
          selectedRowsOnly: true
        }).then(function () {
          workbook.xlsx.writeBuffer().then(function (buffer) {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'CT-es_selecionados.xlsx')
          })
        })
        return
      }

      // Export all data — busca todos os registros via API direta (sem limite de take)
      this.updating = true
      var self = this
      var di = this.dtIniFiltro
      var df = this.dtFimFiltro
      var titulo = this.title

      api.get(getBaseUrl() + 'api/movctesent', {
        params: { skip: 0, isExport: 1, di: di, df: df }
      }).then(function (response) {
        var data = response.data[0]

        // Colunas derivadas — mesma lógica do load()
        data.forEach(function (item, index) {
          if (!isNaN(parseFloat(item.movcte_valor)) && !isNaN(parseFloat(item.movcte_valoratucota))) {
            data[index].movcte_difvalcota = parseFloat(item.movcte_valoratucota) - parseFloat(item.movcte_valor)
          } else { data[index].movcte_difvalcota = null }

          if (!isNaN(parseFloat(item.movcte_valor)) && !isNaN(parseFloat(item.movcte_valormincota))) {
            data[index].movcte_difvalmin = parseFloat(item.movcte_valor) - parseFloat(item.movcte_valormincota)
          } else { data[index].movcte_difvalmin = null }

          if (!isNaN(parseFloat(item.movcte_valor)) && !isNaN(parseFloat(item.movcte_valorprazmin))) {
            data[index].movcte_difprazmin = parseFloat(item.movcte_valor) - parseFloat(item.movcte_valorprazmin)
          } else { data[index].movcte_difprazmin = null }

          if (!isNaN(parseFloat(item.movcte_valor)) && !isNaN(parseFloat(item.movcte_valorcarga))) {
            data[index].movcte_percentualcota = (parseFloat(item.movcte_valor) / parseFloat(item.movcte_valorcarga)) * 100
          } else { data[index].movcte_percentualcota = null }
        })

        var columns = [
          { header: 'ID',              key: 'movcte_id' },
          { header: 'Número',          key: 'movcte_numero' },
          { header: 'Código',          key: 'movcte_codigo' },
          { header: 'Status',          key: 'movcte_status' },
          { header: 'Comprovante',     key: 'movcte_dtcompr' },
          { header: 'Notas Fiscais',   key: 'numnotas' },
          { header: 'Valor Carga',     key: 'movcte_valorcarga' },
          { header: 'Peso B.Calculo',  key: 'movcte_pesovbc' },
          { header: 'Peso Real',       key: 'movcte_pesoreal' },
          { header: 'Cubagem',         key: 'movcte_cubagem' },
          { header: 'Qtd.Und.',        key: 'movcte_qtdund' },
          { header: 'Maior Peso',      key: 'movcte_pesomaior' },
          { header: 'Aliq.ICMS',       key: 'movcte_icmsaliq' },
          { header: 'Vlr. ICMS',       key: 'movcte_icmsvalor' },
          { header: 'CEP Origem',      key: 'movcte_remetcep' },
          { header: 'CEP Destino',     key: 'movcte_destcep' },
          { header: 'Emissão',         key: 'movcte_dtemissao' },
          { header: 'Previsão',        key: 'movcte_dtpreventr' },
          { header: 'ID DocCob',       key: 'movcte_doccobid' },
          { header: 'Dt. Venc DocCob', key: 'movcte_doccobdtvenc' },
          { header: 'Frete CTe',       key: 'movcte_valor' },
          { header: 'Frete %',         key: 'movcte_percentualcota' },
          { header: 'Frete Conc.',     key: 'movcte_valoratucota' },
          { header: 'Diferença',       key: 'movcte_difvalcota' },
          { header: 'Transp. Nome',    key: 'movcte_emitnome' },
          { header: 'Transp. CNPJ',    key: 'movcte_emitcnpj' },
          { header: 'Transp. Cidade',  key: 'movcte_emitcidade' },
          { header: 'Transp. Estado',  key: 'movcte_emitestado' },
          { header: 'Remet. Nome',     key: 'movcte_remetnome' },
          { header: 'Remet. CNPJ',     key: 'movcte_remetcnpj' },
          { header: 'Remet. Cidade',   key: 'movcte_remetcidade' },
          { header: 'Remet. Estado',   key: 'movcte_remetestado' },
          { header: 'Dest. Nome',      key: 'movcte_destnome' },
          { header: 'Dest. CNPJ',      key: 'movcte_destcnpj' },
          { header: 'Dest. Cidade',    key: 'movcte_destcidade' },
          { header: 'Dest. Região',    key: 'movcte_destregiao' },
          { header: 'Dest. Estado',    key: 'movcte_destestado' },
        ]

        var numericFields = [
          'movcte_valorcarga', 'movcte_pesovbc', 'movcte_pesoreal', 'movcte_cubagem',
          'movcte_qtdund', 'movcte_pesomaior', 'movcte_icmsaliq', 'movcte_icmsvalor',
          'movcte_valor', 'movcte_percentualcota', 'movcte_valoratucota', 'movcte_difvalcota'
        ]

        var workbook = new Workbook()
        var worksheet = workbook.addWorksheet('plan1')
        worksheet.columns = columns

        data.forEach(function (item) {
          var row = {}
          columns.forEach(function (col) {
            var val = item[col.key]
            if (numericFields.includes(col.key) && val !== null && val !== undefined) {
              row[col.key] = Math.round(parseFloat(val) * 100) / 100
            } else {
              row[col.key] = val
            }
          })
          worksheet.addRow(row)
        })

        worksheet.eachRow(function (row, rowNumber) {
          if (rowNumber === 1) return
          row.eachCell(function (cell, colNumber) {
            var col = columns[colNumber - 1]
            if (col && numericFields.includes(col.key)) {
              cell.numFmt = '0.00'
            }
          })
        })

        workbook.xlsx.writeBuffer().then(function (buffer) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), titulo + '.xlsx')
          self.updating = false
        })
      }).catch(function (error) {
        console.error('Erro ao exportar:', error)
        self.updating = false
      })
    },


    // ==========================================================================
    // FLUXO NOVO DE EXPORTAÇÃO
    // A planilha é gerada no servidor, em blocos. Estes métodos não tocam em
    // `updating` (que desmontaria a grid), nem no onExporting(), nem no estado
    // da grid. Para desativar, comente os DxItem marcados na toolbar e
    // descomente o <DxExport> no DxDataGrid.
    // ==========================================================================

    exportarPeriodoExcel() {
      console.log('exportarPeriodoExcel')

      if (this.exportando) return

      const filtro = this.dataGrid.getCombinedFilter(true) || null
      const ordenacao = this.dataGrid.getDataSource().sort() || null

      const temFiltro = !!filtro
      const total = this.dataGrid.totalCount()
      const quantos = temFiltro
          ? 'os CT-es que atendem aos filtros aplicados'
          : `${total} CT-es`

      // Frete %, Diferença e as demais colunas derivadas são calculadas aqui no
      // navegador e não existem no banco — o servidor não consegue aplicá-las.
      const calculadas = this.filtrosEmColunasCalculadas(filtro)

      let aviso = ''
      if (calculadas.length > 0) {
        aviso = `<br><br><span style="color:#f1734f">Atenção: o filtro aplicado em `
            + `<b>${calculadas.join(', ')}</b> não pode ser reproduzido na planilha, `
            + `porque essa coluna é calculada na tela. O arquivo virá com mais linhas `
            + `do que a grid está exibindo.</span>`
      }

      Swal.fire({
        icon: 'question',
        title: 'Exportar para Excel',
        html: `Serão exportados <b>${quantos}</b> do período de `
            + `<b>${moment(this.dtIniFiltro).format('DD/MM/YYYY')}</b> a `
            + `<b>${moment(this.dtFimFiltro).format('DD/MM/YYYY')}</b>.`
            + `<br><br>Períodos longos podem levar alguns minutos.`
            + aviso,
        showCancelButton: true,
        confirmButtonText: 'Exportar',
        cancelButtonText: 'Cancelar'
      }).then((escolha) => {
        if (!escolha.isConfirmed) return
        this.baixarPlanilhaCtes(filtro, ordenacao)
      })
    },

    // Percorre a árvore de filtros do DevExtreme procurando colunas que só
    // existem no cliente, para poder avisar antes de exportar.
    filtrosEmColunasCalculadas(no) {
      const rotulos = {
        movcte_difvalcota: 'Diferença',
        movcte_difvalmin: 'Dif. Menor Frete',
        movcte_difprazmin: 'Dif. Menor Prazo',
        movcte_percentualcota: 'Frete %'
      }
      const achados = []

      const percorre = (item) => {
        if (!Array.isArray(item) || item.length === 0) return
        if (typeof item[0] === 'string') {
          if (rotulos[item[0]] && !achados.includes(rotulos[item[0]])) {
            achados.push(rotulos[item[0]])
          }
          return
        }
        item.forEach(percorre)
      }
      percorre(no)

      return achados
    },

    baixarPlanilhaCtes(filtro, ordenacao) {
      this.exportando = true

      Swal.fire({
        title: 'Gerando a planilha...',
        html: 'A tela continua disponível. O download começa automaticamente quando o arquivo ficar pronto.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading()
      })

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      api.post(`${getBaseUrl()}api/movctesentexport`, {
        di: di,
        df: df,
        filtro: filtro ? JSON.stringify(filtro) : null,
        ordenacao: ordenacao ? JSON.stringify(ordenacao) : null
      }, {
        responseType: 'blob'
      }).then((res) => {
        const nome = `CT-es_${di}_a_${df}.xlsx`
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = nome
        link.click()
        window.URL.revokeObjectURL(url)

        Swal.fire({
          icon: 'success',
          title: 'Planilha gerada',
          html: `O download de <b>${nome}</b> foi iniciado.`,
          timer: 4000,
          timerProgressBar: true
        })
      }).catch((error) => {
        console.error('Erro ao exportar CT-es:', error)
        // com responseType blob o corpo do erro vem como Blob, não como JSON
        const status = error.response ? error.response.status : null
        Swal.fire({
          icon: 'error',
          title: 'Não foi possível gerar a planilha',
          html: status
              ? `O servidor respondeu com erro <b>${status}</b>. Tente um período menor ou avise o suporte.`
              : 'A conexão foi interrompida antes do arquivo ficar pronto. Tente um período menor.'
        })
      }).finally(() => {
        this.exportando = false
      })
    },

    exportarSelecionadosExcel() {
      console.log('exportarSelecionadosExcel')

      if (this.exportando) return

      const selecionados = this.dataGrid.getSelectedRowKeys()
      if (!selecionados || selecionados.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Nenhum CT-e selecionado',
          text: 'Marque ao menos uma linha para exportar, ou use "Exportar período" para exportar todos.'
        })
        return
      }

      this.exportando = true

      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet('plan1')

      exportDataGrid({
        component: this.dataGrid,
        worksheet,
        selectedRowsOnly: true
      }).then(() => {
        return workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'CT-es_selecionados.xlsx')
          Swal.fire({
            icon: 'success',
            title: 'Planilha gerada',
            html: `<b>${selecionados.length}</b> CT-e(s) exportado(s).`,
            timer: 3000,
            timerProgressBar: true
          })
        })
      }).catch((error) => {
        console.error('Erro ao exportar selecionados:', error)
        Swal.fire({
          icon: 'error',
          title: 'Não foi possível gerar a planilha',
          text: 'Ocorreu uma falha ao montar o arquivo dos CT-es selecionados.'
        })
      }).finally(() => {
        this.exportando = false
      })
    },

    // ===================== fim do FLUXO NOVO DE EXPORTAÇÃO =====================

    refeFormTable() {
      console.log('refeFormTable')
      this.dataGrid.state(null);
    },


    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div>

      <div class="col-12 mb-3 text-center toolbar-label">
        Listagem de <b>{{ this.title }}</b>
      </div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="upload"
              id="btnImportarXml"
              text="Importar arquivo XML"
              hint="Importar arquivo XML"
              :on-click="novoCte"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              id="btnInserirXml"
              hint="Criar Novo CT-e"
              text="Criar Novo CT-e"
              :on-click="criarNovoCte"/>
        </DxItem>


        <DxItem
            v-if="!bloqExibEconofrete"
            location="before"
            widget="dxButton">
          <DxButton
              icon="decreaseindent"
              hint="Cotar Frete (Econofrete)"
              :on-click="cotarFrete"/>
        </DxItem>



        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="decreaseindent"
              hint="Cotar Frete (Econopro)"
              :on-click="cotarFreteInterno"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="dragvertical"
              hint="Conciliação Assíncrona"
              :on-click="abrirConcAssinc"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="dragvertical"
              hint="Comparação Assíncrona"
              :on-click="abrirCompAssinc"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="columnchooser"
              hint="Cotações de Comparação"
              :on-click="abrirCteCotaComp"/>
        </DxItem>



        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="checklist"
              hint="Histórico de Conciliações"
              :on-click="abrirFreteCotaComp"/>
        </DxItem>
        

        <DxItem
          location="before"
          widget="dxButton">
          <DxButton
            icon="download"
            hint="Imprimir DANCTE"
            :on-click="imprimirdancte"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="exportselected"
              hint="Gerar DocCob de Itens Selecionados"
              :on-click="gerarDoccob"/>
        </DxItem>

        <!-- ==========================================================================
             FLUXO NOVO DE EXPORTAÇÃO — comentar os dois DxItem abaixo e descomentar
             o <DxExport> no DxDataGrid para voltar ao fluxo antigo.
             ========================================================================== -->
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="xlsxfile"
              text="Exportar período"
              hint="Exportar para Excel todos os CT-es do período (respeita os filtros das colunas)"
              :disabled="exportando"
              :on-click="exportarPeriodoExcel"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="xlsxfile"
              hint="Exportar para Excel apenas os CT-es selecionados"
              :disabled="exportando"
              :on-click="exportarSelecionadosExcel"/>
        </DxItem>
        <!-- ===================== fim do FLUXO NOVO DE EXPORTAÇÃO ==================== -->


<!--        <DxItem
            location="center"
            locate-in-menu="never">
          <div class="toolbar-label">Listagem de <b>{{ this.title }}</b></div>
        </DxItem>-->

        <DxItem
            location="after"
            widget="dxItem">
          <DxButton
              id="btnAjuda"
              icon="help"
              style="background-color: #50a5f1; color: white;"
              text="Ajuda"
              type="normal"
              :on-click="ajuda"/>
        </DxItem>

      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2">
      <p><strong>Itens Selecionados: {{ selectedItems }}</strong></p>
    </div>

    <div class="mt-2" v-if="!updating">

      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @content-ready="carregouGrid"
          @row-dbl-click="onRowDblClick"
          @exporting="onExporting"
          @selection-changed="atualizarItensSelecionados"
      >
        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true"/>


        <DxSelection mode="multiple"/>

        <!-- ==========================================================================
             FLUXO ANTIGO DE EXPORTAÇÃO (menu "Export to Excel" do DevExtreme)
             Desativado em favor dos botões "Exportar período" / "Exportar selecionados"
             da toolbar, que geram a planilha no servidor.

             PARA VOLTAR AO FLUXO ANTIGO: descomentar o <DxExport> abaixo e comentar
             os dois DxItem marcados como "FLUXO NOVO DE EXPORTAÇÃO" na toolbar.
             O onExporting() segue intacto e volta a ser acionado automaticamente.
             ========================================================================== -->
        <!--
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        -->

        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strCteList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping/>

        <DxColumn :width="80"
                  sort-order="desc"
                  data-field="movcte_id"
                  :fixed-position="left"
                  caption="ID"
                  alignment="right"
                  data-type="number"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn
            :width="80"
            data-field="movcte_numero"
            caption="Número"
            alignment="right"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            :width="80"
            data-field="movcte_codigo"
            caption="Código"
            alignment="right"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            :width="80"
            data-field="movcte_status"
            caption="Status"
            alignment="right"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="movcte_dtcompr"
            caption="Comprovante"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            :width="80"
            data-field="numnotas"
            caption="Notas Fiscais"
            alignment="right"
            data-type="text"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowSorting="false"
            :allowFiltering="true">
        </DxColumn>

        <DxColumn
            :width="80"
            data-field="movcte_valorcarga"
            caption="Valor Carga"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="movcte_pesovbc"
            caption="Peso B.Calculo"
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allow-sorting="false"
            :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn
            data-field="movcte_pesoreal"
            caption="Peso Real"
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allow-sorting="false"
            :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn
            data-field="movcte_cubagem"
            caption="Cubagem"
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allow-sorting="false"
            :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn
            data-field="movcte_qtdund"
            caption="Qtd.Und."
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allow-sorting="false"
            :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn
            data-field="movcte_pesomaior"
            caption="Maior Peso"
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allow-sorting="false"
            :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn
            data-field="movcte_icmsaliq"
            caption="Aliq.ICMS"
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allow-sorting="false"
            :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn
            data-field="movcte_icmsvalor"
            caption="Vlr. ICMS"
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allow-sorting="false"
            :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn
            data-field="movcte_remetcep"
            caption="CEP Origem"
            alignment="right"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="movcte_destcep"
            caption="CEP Destino"
            alignment="right"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allow-sorting="false"
            :allowHeaderFiltering="false"/>

        <DxColumn
            :width="100"
            data-field="movcte_dtemissao"
            caption="Emissão"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            :width="100"
            data-field="movcte_dtpreventr"
            caption="Previsão"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            :width="110"
            caption="DocCob CTe"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              :width="100"
              data-field="movcte_doccobid"
              caption="ID DocCob"
              alignment="right"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              :width="130"
              data-field="movcte_doccobdtvenc"
              caption="Dt. Venc DocCob"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>
        </DxColumn>

        <!--        <DxColumn-->
        <!--            data-field="movcte_valor"-->
        <!--            :fixed="true"-->
        <!--            fixed-position="left"-->
        <!--            caption="Frete CTe"-->
        <!--            alignment="right"-->
        <!--            :format="formatDecimal"-->
        <!--            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"-->
        <!--            :allowHeaderFiltering="false"/> &lt;!&ndash;Valor&ndash;&gt;-->

        <!--    Conciliação       -->
        <DxColumn
            :width="110"
            caption="Conciliação"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="movcte_valor"
              caption="Frete CTe"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/> <!--Valor-->

          <DxColumn
              data-field="movcte_percentualcota"
              caption="Frete %"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="movcte_valoratucota"
              caption="Frete Conc."
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/> <!--Valor Conc.-->

          <DxColumn
              data-field="movcte_difvalcota"
              caption="Diferença"
              alignment="right"
              :format="formatDecimal"
              @cell-prepared="onCellPrepared"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

        </DxColumn>

        <!--    Menor Frete       -->
        <!-- <DxColumn -->
            <!-- :width="110" -->
            <!-- caption="Menor Frete" -->
            <!-- alignment="center" -->
            <!-- :allow-sorting="false" -->
            <!-- :allowHeaderFiltering="false"> -->
          <!-- <DxColumn -->
              <!-- data-field="movcte_valormincota" -->
              <!-- caption="Frete Valor" -->
              <!-- alignment="right" -->

              <!-- :format="formatDecimal" -->
              <!-- :filter-operations="['=', '<>', '<', '>', '<=', '>=']" -->
              :allowHeaderFiltering="false"/> Valor Conc.

          <!--          <DxColumn-->
          <!--              data-field="movcte_percvalmin"-->
          <!--              caption="Frete %"-->
          <!--              alignment="right"-->
          <!--              fixed-position="right"-->
          <!--              :format="formatDecimal"-->
          <!--              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"-->
          <!--              :allowHeaderFiltering="false" />-->

          <!-- <DxColumn -->
              <!-- data-field="movcte_difvalmin" -->
              <!-- caption="Diferença" -->
              <!-- alignment="right" -->
              <!-- :format="formatDecimal" -->
              <!-- :filter-operations="['=', '<>', '<', '>', '<=', '>=']" -->
              <!-- :allowHeaderFiltering="false"/> -->

          <!-- <DxColumn -->
              <!-- data-field="movcte_prazovalmin" -->
              <!-- caption="Prazo" -->
              <!-- alignment="right" -->
              <!-- :format="formatInteger" -->
              <!-- :filter-operations="['=', '<>', '<', '>', '<=', '>=']" -->
              <!-- :allowHeaderFiltering="false"/> -->
        <!-- </DxColumn> -->

        <!--    Menor Prazo       -->
        <!-- <DxColumn -->
            <!-- :width="110" -->
            <!-- caption="Menor Prazo" -->
            <!-- alignment="center" -->
            <!-- :allow-sorting="false" -->
            <!-- :allowHeaderFiltering="false"> -->

          <!-- <DxColumn -->
              <!-- data-field="movcte_valorprazmin" -->
              <!-- caption="Frete Valor" -->
              <!-- alignment="right" -->
              <!-- :format="formatDecimal" -->
              <!-- :filter-operations="['=', '<>', '<', '>', '<=', '>=']" -->
              <!-- :allowHeaderFiltering="false"/> -->

          <!--          <DxColumn-->
          <!--              data-field="movcte_percprazmin"-->
          <!--              caption="Frete %"-->
          <!--              alignment="right"-->
          <!--              fixed-position="right"-->
          <!--              :format="formatDecimal"-->
          <!--              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"-->
          <!--              :allowHeaderFiltering="false" />-->

          <!-- <DxColumn -->
              <!-- data-field="movcte_difprazmin" -->
              <!-- caption="Diferença" -->
              <!-- alignment="right" -->
              <!-- :format="formatDecimal" -->
              <!-- :filter-operations="['=', '<>', '<', '>', '<=', '>=']" -->
              <!-- :allowHeaderFiltering="false"/> -->

          <!-- <DxColumn -->
              <!-- data-field="movcte_prazomincota" -->
              <!-- caption="Prazo" -->
              <!-- alignment="right" -->
              <!-- :format="formatInteger" -->
              <!-- :filter-operations="['=', '<>', '<', '>', '<=', '>=']" -->
              <!-- :allowHeaderFiltering="false"/> -->
        <!-- </DxColumn> -->

        <DxColumn
            :width="330"
            caption="Transportador"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="movcte_emitnome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="movcte_emitcnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="movcte_emitcidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="movcte_emitestado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>


        <DxColumn
            :width="330"
            caption="Remetente"
            alignment="center"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="movcte_remetnome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="movcte_remetcnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="movcte_remetcidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="movcte_remetestado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>

        <DxColumn
            :width="330"
            caption="Destinatário"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="movcte_destnome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="movcte_destcnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="movcte_destcidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="movcte_destregiao"
              caption="Região"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="movcte_destestado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span>Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span>Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal title="Cotação de Fretes CT-e" v-model="showCotaFrete" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">O CEP informado abaixo vai sobrepor o CEP de todos os CT-e's a conciliar, caso não seja necessário a sobreposição basta deixar o campo em branco.</label>

        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="cepdest">CEP Destinatário</label>
            <input
                id="cepdest"
                v-model="cepDestCotaInt"
                type="text"
                class="form-control"
                placeholder="CEP Destinatário"/>
          </div>
        </div>
      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showCotaFrete = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confCotarFreteInterno">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal title="Gerar DocCob de CT-e" v-model="showGeraDoccob" centered hide-footer>

      <Loader v-if="updatingdoccob" style="min-height: 400px;">
      </Loader>

      <div class="row" v-if="!updatingdoccob">
        <div class="row mb-3">
          <div class="col-8 ">
            <label for="tomado_doccob">Tomador</label>
            <multiselect id="tomado_doccob"
                         @search-change="pesqPessoa"
                         @select="escolheuPessoa"
                         v-model="tomadorDoccob"
                         placeholder="Indique o Tomador"
                         :options="dtListPesqPessoa"
                         :searchable="true"
                         class="multiselect-size"
                         :disabled="emitsctes_doccob?.length < 1"
                         label="nome"
                         track-by="nome"
                         value-prop="cnpj">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="font-size-12 text-info">{{ slotProps.option.cnpj }}</span>
                  </div>
                  <div class="font-size-16">
                    {{ slotProps.option.nome }}
                  </div>
                </div>
              </template>
            </multiselect>
          </div>

          <div class="col-4">
            <label for="dtvenc_doccob">Dt. Vencimento:</label>
            <input
                id="dtvenc_doccob"
                v-model="dtVencDoccob"
                type="date"
                :disabled="emitsctes_doccob?.length < 1"
                class="form-control font-size-16"
                placeholder="Definir Dt. Vencimento"
            />
          </div>
        </div>

        <div class="col-12 mt-3">
          <div class="mb-3">
            <label for="emits_doccob" class="p-1">CTe's e Emitentes listados para gerar doccob:</label>

            <div class="row mb-2" v-if="emitsctes_doccob?.length > 0">
              <div class="table-responsive" style="max-height: 350px; min-height: 350px; overflow-y: auto;">
                <table class="table align-middle mb-0 table-nowrap">
                  <thead class="table-light" style="position: sticky; top: 0; z-index: 5;">
                    <tr>
                      <th class="text-start ps-5" style="max-width: 250px;">Emitente</th>
                      <th class="text-center">Cnpj</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(data, index) in emitsctes_doccob" :key="data.cnpj">
                      <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                        <td class="text-start" style="padding-top: 3px; padding-bottom: 3px; max-width: 250px;">
                          {{ data.nome.length > 35 ? data.nome.substring(0, 30) + '...' : data.nome }}
                        </td>
                        <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">{{ data.cnpj }}</td>
                      </tr>

                      <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                        <td colspan="2"
                            class="text-muted small ps-3"
                            style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;
                            white-space: normal; word-wrap: break-word; word-break: break-word"
                        >
                          {{ data.numero }}
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-else>
              <b-alert variant="warning" show>
                <p class="alert-heading">Nenhum CT'e Selecionado!</p>
              </b-alert>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end mt-5" v-if="!updatingdoccob">
        <b-button variant="light" @click="showGeraDoccob = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" :disabled="emitsctes_doccob?.length < 1" @click="confirmaGerarDoccob">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal id="showModalListErro" size="xl" title="Relatório de erros ao registrar DocCob" v-model="showModalListErro" @hidden="refeFormTable" centered hide-footer>
      <div class="col-md-12">
        <template v-for="(data, index) in dtListErro" :key="index">

          <!-- Cabeçalho do emitente -->
          <div class="alert alert-warning py-2 mb-2">
            <div class="d-flex justify-content-between flex-wrap gap-2">
              <div><strong>Emitente:</strong> {{ data.emitnome }} &nbsp;|&nbsp; <span class="text-muted">{{ data.emitcnpj }}</span></div>
              <div><strong>Tomador:</strong> {{ data.tomador?.nome }} &nbsp;|&nbsp; <span class="text-muted">{{ data.tomador?.cnpj }}</span></div>
            </div>
          </div>

          <!-- Erro: CT-es já vinculados a DocCob(s) — exibe quais DocCobs -->
          <div v-if="data.doccobs && data.doccobs.length" class="mb-4">
            <p class="text-danger mb-1 fw-semibold">
              <i class="bx bx-error-circle me-1"></i>{{ data.message }}
            </p>
            <div class="table-responsive">
              <table class="table table-sm table-bordered align-middle mb-0">
                <thead class="table-danger">
                  <tr>
                    <th>ID DocCob</th>
                    <th>Referência</th>
                    <th>Data Emissão</th>
                    <th>CT-e(s) já vinculado(s)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="doccob in data.doccobs" :key="doccob.doccob_id">
                    <td class="fw-bold text-primary">{{ doccob.doccob_id }}</td>
                    <td>{{ doccob.doccob_iddoc }}</td>
                    <td>{{ doccob.doccob_dtemissao }}</td>
                    <td>{{ Array.isArray(doccob.numeros) ? doccob.numeros.join(', ') : doccob.numeros }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Outros erros genéricos (ex: CT-e não encontrado) -->
          <div v-else class="alert alert-danger py-2 mb-3">
            <strong><i class="bx bx-x-circle me-1"></i>{{ data.message }}</strong><br>
            <span class="text-muted">CT-e(s): {{ Array.isArray(data.numero) ? data.numero.join(', ') : data.numero }}</span>
          </div>

          <hr v-if="index < dtListErro.length - 1" class="my-2">
        </template>
      </div>
    </b-modal>
  </Layout>
</template>



<style>
#btnAjuda .dx-icon {
  color: #fff !important;
}
</style>

